import React from 'react';
import { FragmentData, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

import { Toggle } from '@reckon-web/toggle';
import { useToasts } from '@reckon-web/toast';

import { usersFragment } from '../UsersTable';

// gql
const fragment = gql`
  fragment User_Partner on TenantUser {
    __typename
    partner
  }
` as import('../../../../__generated__/ts-gql/User_Partner').type;

const UPDATE_PARTNER = gql`
  mutation UpdateTenantUserPartner($input: TenantUserPartnerInput!) {
    updateTenantUserPartner(input: $input)
  }
` as import('../../../../__generated__/ts-gql/UpdateTenantUserPartner').type;

// component
export function Partner({
  tenantUser,
  canEditUser,
}: {
  tenantUser: FragmentData<typeof usersFragment>;
  canEditUser?: boolean;
}) {
  const { addToast } = useToasts();
  const [updatePartner] = useMutation(UPDATE_PARTNER);
  const onToggle = async () => {
    if (tenantUser.cloudId) {
      try {
        const data = await updatePartner({
          variables: {
            input: {
              cloudId: tenantUser.cloudId,
              modifiedBy: 'TUM',
              partner: !tenantUser.partner,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateTenantUserPartner: true,
          },
          update: (cache) => {
            cache.writeFragment({
              id: tenantUser.cloudId || '',
              fragment: fragment,
              data: {
                __typename: 'TenantUser',
                partner: !tenantUser.partner,
              },
            });
          },
        });
        addToast({
          tone: 'positive',
          title: 'Partner update success',
        });
        if (!data.data?.updateTenantUserPartner) {
          addToast({
            tone: 'warning',
            title: "Something isn't right, please check the console",
          });
        }
      } catch (error: any) {
        let err = error?.message || error;
        if (err.includes('GraphQL error:'))
          err = err.replace('GraphQL error: ', '');
        addToast({
          tone: 'critical',
          title: `Update failed`,
          message: `${err}`,
        });
      }
    }
  };
  if (tenantUser.apsUserId === 0) {
    return <React.Fragment />;
  }
  return (
    <Toggle
      checked={tenantUser.partner || undefined}
      disabled={!canEditUser}
      onChange={onToggle}
    />
  );
}
